import { inputToTags, tagsToInput } from "../../mst/kinds/utils";
import { getDefaultBaseInput, OptimisticConcurrency } from "../../schema/types/base";
import { LocationInput } from "../../schema/types/location/input";
import { Location } from "../../schema/types/location/entity";
import { LocationCreate } from "../../schema/types/location/create";

export function getDefaultLocationInput(): LocationInput {
  return {
    ...getDefaultBaseInput(),
    version: 0,
    id: "",
    meta: {
      isEdit: false,
    },
  };
}

export function inputToLocation(input: LocationInput): LocationCreate {
  const res: LocationCreate = {
    name: input.name,
    kind: "location",
    tags: inputToTags(input.tags),
    origin: "custom",
    provider: "byok",
  };
  if (input.description) {
    res.description = input.description;
  }
  return res;
}

export function locationToInput(location: Location): LocationInput {
  const def = getDefaultLocationInput();
  const res: LocationInput = {
    ...def,
    version: location.version,
    id: location.id,
    name: location.name,
    description: location.description,
    tags: tagsToInput(location.tags),
    meta: {
      ...def.meta,
      isEdit: true,
    },
  };
  return res;
}

export function locationToPatch(_location: LocationCreate, concurrency: OptimisticConcurrency) {
  const location: any = JSON.parse(JSON.stringify(_location));

  location[`$replace/tags`] = location.tags;
  delete location.tags;

  location.id = concurrency.id;
  location.version = concurrency.version;

  return location;
}
